import { render } from "./WidgetLayout.vue?vue&type=template&id=2dc1452c&scoped=true"
import script from "./WidgetLayout.vue?vue&type=script&lang=js"
export * from "./WidgetLayout.vue?vue&type=script&lang=js"

import "./WidgetLayout.vue?vue&type=style&index=0&id=2dc1452c&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dc1452c"]])

export default __exports__